import React, { useRef, useState } from "react";
import constants from "../../constants";
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useFormContext } from "react-hook-form";

function DeliveryAddressField({ label, name, control, readOnly = false }) {
    const checkout = useSelector((state) => state.checkout);

    const ref = useRef();

    const {setValue, watch} = useFormContext();

    function handleSelectAddress(e, onChange) {
        setValue('selectedAddress', e.target.value);

        if (e.target.value !== 'other') {
            const deliveryAddress = checkout.payload.deliveryAddresses.find(x => x.systemId === e.target.value);

            setValue(`shippingAddress.address1`, deliveryAddress.address1);
            setValue(`shippingAddress.zipCode`, deliveryAddress.zipCode);
            setValue(`shippingAddress.city`, deliveryAddress.city);
            setValue(`shippingAddress.country`, deliveryAddress.country);
            setValue(`shippingAddress.state`, deliveryAddress.state);
            setValue(`companyName`, deliveryAddress.customData?.companyName ?? "");
        } else {
            setValue(`shippingAddress.address1`, '');
            setValue(`shippingAddress.zipCode`, '');
            setValue(`shippingAddress.city`, '');
            setValue(`shippingAddress.country`, '');
            setValue(`shippingAddress.state`, '');
            setValue(`companyName`, '');
        }

        onChange(e);
    }

    const deliveryAddressCountries = constants.deliveryAddressCountries;

    const deliveryAddresses = checkout.payload.deliveryAddresses.filter(x => {
        if (deliveryAddressCountries.length > 0) {
            return deliveryAddressCountries.includes(x.country);
        }

        return true;
    });

    if(deliveryAddresses.length === 0){
        return null;
    }

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <div>
                    {
                        label && <label htmlFor=""
                                        className="checkout__label">{label}</label>
                    }

                    <select
                        value={value}
                        ref={ref}
                        onChange={(event) => handleSelectAddress(event, onChange)}
                        className="checkout__input"
                    >
                        {
                            deliveryAddresses.map(x => {
                                return (
                                    <option
                                        value={x.systemId}>{x.address1}, {x.zipCode}, {x.country}</option>);
                            })
                        }

                        <option value="other">Other address</option>

                    </select>

                    {error &&
                        <p className="checkout__input-validation-error">{error.message}</p>}
                </div>
            )}
        />
    )
}

export default DeliveryAddressField;
